export interface IDeclaraciones {
  declaracionVeracidad?: boolean;
  compromisoActualizacion?: boolean;
  aceptacionPrivacidad?: boolean;
  aceptacionLineamientos?: boolean;
}

export class Declaraciones implements IDeclaraciones {
  constructor(
    public declaracionVeracidad?: boolean,
    public compromisoActualizacion?: boolean,
    public aceptacionPrivacidad?: boolean,
    public aceptacionLineamientos?: boolean
  ) {
    this.declaracionVeracidad = declaracionVeracidad;
    this.compromisoActualizacion = compromisoActualizacion;
    this.aceptacionPrivacidad = aceptacionPrivacidad;
    this.aceptacionLineamientos = aceptacionLineamientos;
  }
}
